import Image from "next/image";

export type TechBadgeType =
  | "html"
  | "next"
  | "react"
  | "tailwind"
  | "laravel"
  | "express"
  | "wordpress"
  | "mongo"
  | "mysql"
  | "nginx"
  | "server"
  | "nodejs"
  | "typescript"
  | "aws";

export default function TechBadge({ type }: { type: TechBadgeType }) {
  const types = {
    html: {
      name: "HTML",
      iconUrl: "/icons/skills/html_css_js.svg",
    },
    next: {
      name: "Next",
      iconUrl: "/icons/skills/nextjs.svg",
    },
    react: {
      name: "React",
      iconUrl: "/icons/skills/react.svg",
    },
    tailwind: {
      name: "Tailwind",
      iconUrl: "/icons/skills/tailwindcss.svg",
    },
    laravel: {
      name: "Laravel",
      iconUrl: "/icons/skills/laravel.svg",
    },
    express: {
      name: "Express",
      iconUrl: "/icons/skills/expressjs.svg",
    },
    wordpress: {
      name: "WordPress",
      iconUrl: "/icons/skills/wordpress.svg",
    },
    mongo: {
      name: "Mongo",
      iconUrl: "/icons/skills/mongo.svg",
    },
    mysql: {
      name: "MySQL",
      iconUrl: "/icons/skills/mysql.svg",
    },
    nginx: {
      name: "Nginx",
      iconUrl: "/icons/skills/nginx.svg",
    },
    server: {
      name: "Server",
      iconUrl: "/icons/skills/server.svg",
    },
    aws: {
      name: "AWS",
      iconUrl: "/icons/skills/aws.svg",
    },
    nodejs: {
      name: "NodeJS",
      iconUrl: "/icons/skills/nodejs.svg",
    },
    typescript: {
      name: "Typescript",
      iconUrl: "/icons/skills/typescript.svg",
    },
  };

  return (
    <span
      id="badge-dismiss-default"
      className="inline-flex items-center px-2 py-1 me-2 text-sm font-medium text-blue-800 bg-blue-100 rounded dark:bg-blue-900 dark:text-blue-300"
    >
      {types[type].name}
      <Image
        alt={types[type].name}
        src={types[type].iconUrl}
        width={16}
        className="ml-1"
        height={16}
      />
    </span>
  );
}
